/**
 * Procedure Categories and Procedures for M.Ch. in Surgical Gastroenterology students
 * Extracted with strict evidence from official NMC PDF (Page 12-17: "Psychomotor Domain - perform independently")
 */
export const SURGICAL_GASTROENTEROLOGY_PROCEDURES = {
  "Upper GI, Esophageal & Bariatric Surgical Procedures": [
    "Esophageal Resection (Ivor Lewis, McKeown, Transhiatal Esophagectomy)",
    "Fundoplication & Heller's Cardiomyotomy for GERD & Achalasia",
    "Subtotal & Total Gastrectomy with D2 Lymph Node Dissection",
    "Open & Laparoscopic Peptic Ulcer Surgery (Vagotomy, Pyloroplasty, Gastrojejunostomy)",
    "Bariatric Surgery (Laparoscopic Sleeve Gastrectomy & Roux-en-Y Gastric Bypass)",
    "Endoscopic Dilatation, Variceal Banding, Foreign Body Removal & EUS Procedures",
  ],
  "Colorectal, Small Bowel & Anal Reconstructive Procedures": [
    "Colectomy (Right/Left Hemicolectomy, Sigmoidectomy, Total Colectomy)",
    "Low & Ultra-Low Anterior Resection (LAR/ULAR) & Abdominoperineal Resection (APR)",
    "Restorative Proctocolectomy with Ileoanal Pouch Anastomosis (J-Pouch)",
    "Creation & Reversal of Stomas (Ileostomy, Colostomy) & Trans-Anal Procedures (TEMS/TAMIS)",
    "Small Bowel Resection & Anastomosis for Ischemia, Perforation, Obstruction & Fistulae",
  ],
  "Hepatobiliary, Pancreatic & Transplant Surgical Procedures": [
    "Major Anatomical Liver Resection (Segmentectomy, Lobectomy, Extended Hepatectomy)",
    "Portosystemic Shunt Operations (Portocaval, Mesocaval, Splenorenal) & Devascularization",
    "Extended Cholecystectomy for Gallbladder Cancer & Klatskin Tumor Resection",
    "Resection & Roux-en-Y Hepaticojejunostomy for Choledochal Cysts & Strictures",
    "Pancreatoduodenectomy (Whipple Procedure) & Distal Pancreatectomy",
    "Drainage & Reconstructive Surgery for Pancreatitis (Frey Procedure, Pseudocyst Drainage)",
    "Donor Hepatectomy, Organ Preservation & Liver Transplantation",
  ],
};

export const SURGICAL_GASTROENTEROLOGY_CATEGORIES = Object.keys(SURGICAL_GASTROENTEROLOGY_PROCEDURES);

export const isMChInSurgicalGastroenterologyDept = (department) => {
  if (!department) {
    try {
      const u = JSON.parse(
        localStorage.getItem("userData") || localStorage.getItem("user") || "{}"
      );
      department = u.department || (u.departments && u.departments[0]);
    } catch (e) {}
  }
  if (!department) return false;
  const d = String(department).toLowerCase();
  return (
    d.includes("surgical gastroenterology") ||
    d.includes("surgical gastro") ||
    d.includes("gi surgery") ||
    d.includes("gastrointestinal surgery") ||
    d.includes("gastroenterology surgery")
  );
};
